module.exports = __webpack_public_path__ + "static/media/lock.9a2978af.svg";